import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {NavParams, PopoverController} from "@ionic/angular";
import {Dayjs} from "dayjs";
import * as dayjs from "dayjs";

export interface StartEndDate {
    start: Dayjs | null,
    end: Dayjs | null
}

@Component({
    selector: 'app-date-input-popover',
    templateUrl: './date-input-popover.component.html',
    styleUrls: ['./date-input-popover.component.scss'],
})

export class DateInputPopoverComponent implements OnInit {

    @Input() startDate: Dayjs | null | undefined | string;
    _startDate: Dayjs = dayjs('');
    @Input() endDate: Dayjs | null | undefined | string;
    _endDate: Dayjs = dayjs('');
    @Input() minDate: Dayjs | null | undefined | string;
    _minDate: Dayjs = dayjs('');
    @Input() maxDate: Dayjs | null | undefined | string;
    _maxDate: Dayjs = dayjs('');

    @Input() invalidDays: Date[] | undefined;

    @Input() locale = {};

    @Input() singleDatePicker: boolean = true;
    @Input() timePicker: boolean = false;

    @Output() dateChange = new EventEmitter<StartEndDate>();

    constructor(
        private navParams: NavParams,
        private popoverCtrl: PopoverController
    ) {
    }

    ngOnInit() {
        if (this.startDate) this._startDate = dayjs(this.startDate);
        else this._startDate = dayjs();
        if (this.singleDatePicker) {
            this._endDate = dayjs(this._startDate);
        } else {
            if (this.endDate) this._endDate = dayjs(this.endDate);
            else this._endDate = dayjs();
        }
        if (this.minDate) this._minDate = dayjs(this.minDate);
        if (this.maxDate) this._maxDate = dayjs(this.maxDate);
    }

    isInvalidDate = (date: Dayjs): boolean => {
        if (this.invalidDays) {
            return this.invalidDays.some(invDate => date.isSame(invDate, 'day'));
        }
        return false;
    }

    onCancel(): void {
        this.popoverCtrl.dismiss(null, 'cancel');
    }

    choosedDate(event: any): void {
        const data: StartEndDate = {
            start: event.startDate,
            end: event.endDate
        };
        this.dateChange.emit(data);
        this.popoverCtrl.dismiss(data, 'ok');
    }

    cancelClicked(event: Object): void {
        this.popoverCtrl.dismiss(null, 'cancel');
    }

}
